"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMessageStrings = exports.ListMessageType = void 0;
var ListMessageType;
(function (ListMessageType) {
    ListMessageType["success"] = "success";
    ListMessageType["error"] = "error";
    ListMessageType["loading"] = "loading";
})(ListMessageType = exports.ListMessageType || (exports.ListMessageType = {}));
var ListMessageStrings;
(function (ListMessageStrings) {
    ListMessageStrings["createListSuccess"] = "Create list success";
    ListMessageStrings["createListInProgress"] = "Creating a list";
    ListMessageStrings["createListFail"] = "Create a list failed";
    ListMessageStrings["deleteListSuccess"] = "Delete list success";
    ListMessageStrings["deleteListInProgress"] = "Deleting a list";
    ListMessageStrings["deleteListFail"] = "Delete list failed";
    ListMessageStrings["moveItemsInProgress"] = "Moving items in list";
    ListMessageStrings["editListNameInProgress"] = "Changing list name";
    ListMessageStrings["editGroupNameInProgress"] = "Changing group name";
    ListMessageStrings["deleteGroupInProgress"] = "Deleting group";
    ListMessageStrings["deleteGroupSuccess"] = "Delete group success";
    ListMessageStrings["deleteGroupFail"] = "Delete group failed";
    ListMessageStrings["editGroupNameSuccess"] = "Changing group name success";
    ListMessageStrings["resequenceGroupsInProgress"] = "Resequencing groups";
    ListMessageStrings["resequenceGroupsSuccess"] = "Resequencing groups success";
    ListMessageStrings["moveItemsSuccess"] = "Moving items in list success";
    ListMessageStrings["editListNameSuccess"] = "Changing list name success";
    ListMessageStrings["moveItemsFail"] = "Moving items in list failed";
    ListMessageStrings["editListNameFail"] = "Changing list name failed";
    ListMessageStrings["editGroupNameFail"] = "Changing group name failed";
    ListMessageStrings["resequenceGroupsFail"] = "Resequencing groups failed";
    ListMessageStrings["addItemsInProgress"] = "Adding products to list";
    ListMessageStrings["addItemsSuccess"] = "Adding products to list success";
    ListMessageStrings["addItemsFail"] = "Adding products to list failed";
    ListMessageStrings["deleteItemsInProgress"] = "Deleting products from list";
    ListMessageStrings["deleteItemsFail"] = "Delete items from list failed";
    ListMessageStrings["deleteItemsSuccess"] = "Delete items from list success";
    ListMessageStrings["addGroupInProgress"] = "Adding group to list";
    ListMessageStrings["addGroupFail"] = "Adding group to list failed";
    ListMessageStrings["addGroupSuccess"] = "Adding group to list success";
    ListMessageStrings["copyItemsInProgress"] = "Copying items";
    ListMessageStrings["copyItemsFail"] = "Copying items failed";
    ListMessageStrings["copyItemsSuccess"] = "Copying items success";
    ListMessageStrings["replaceProductsInProgress"] = "Replacing products on list";
    ListMessageStrings["replaceProductsFail"] = "Replacing products on list failed";
    ListMessageStrings["replaceProductsSuccess"] = "Replacing products on list success";
    ListMessageStrings["genericError"] = "This list cannot be edited at this time, please try again later.";
})(ListMessageStrings = exports.ListMessageStrings || (exports.ListMessageStrings = {}));
